import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initializeRuntimeConfig } from '@shared/config/runtime';
import { initializeObservability } from '@shared/observability/telemetry';
import { HmsregApp } from './App';
import './theme/theme.css';

function resolveRouterBaseName(basePath: string): string | undefined {
  if (basePath === '/') {
    return undefined;
  }

  return basePath.replace(/\/$/, '');
}

const runtimeConfig = initializeRuntimeConfig({
  variant: 'hmsreg',
  locale: 'nb',
});

initializeObservability();
document.documentElement.lang = runtimeConfig.app.locale;
document.body.classList.add('theme-hmsreg');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={resolveRouterBaseName(runtimeConfig.app.basePath)}>
      <HmsregApp />
    </BrowserRouter>
  </StrictMode>
);
